import React from "react";
import { Route } from "react-router-dom";
import { getRedirectPath, isSuperAdmin } from "../constants/user";
import Redirect from "../components/Redirect";

export function isModuleApproved(user, module) {
  return (
    !!user
    && !!user.modules
    && !!user.modules[module]
    && ['approved', 'active'].includes(user.modules[module].status)
  );
}
export function isClient(user) {
  return (!!user && !!user.modules && !!user.modules.pme && user.modules.pme.role === 'pmeMEC');
}

export function AdminRouter({ path, exact, routes, component: Component, user, visible = () => true }) {
  return visible(user) ? <Route
    path={path}
    exact={exact}
    render={props => (user && !isSuperAdmin(user))
      ? <Redirect to={getRedirectPath(user)} />
      : <Component {...props} routes={routes} />}
  /> : <Redirect to={getRedirectPath(user)} />
}
